<template>
    <div class="search-page" ref="offer">
        <div v-if="isLoaded" class="page-content">
            <div class="cover"></div>
            <div class="container">
                <div class="content">
                    <h1>Vizualizare ofertă</h1>
                    <p>Actualizată ultima oară la {{(new Date(offer.offer.updated_at)).toLocaleString()}}</p>

                    <div class="page" v-if="offer.products.length === 0">
                        <h1>Niciun produs în ofertă</h1>
                        <p>
                            Nu aveți niciun produs adăugat în oferta în lucru. Puteți începe prin a căuta produsul
                            dorit, utilizând căsuța de căutare.
                        </p>
                    </div>

                    <div v-else>
                        <div class="page">
                            <h1>Informații ofertă</h1>

                            <b-row>
                                <b-col md="7">
                                    <h2>Curs de schimb valutar</h2>
                                    <div v-for="exchangeRate in offer.exchange_rates" :key="exchangeRate.currency">
                                        <div class="row">
                                            <div class="col-sm-4 label">1 {{exchangeRate.currency}}</div>
                                            <div class="col-sm-8">
                                                <div v-if="!exchangeRate.markup_type">{{parseFloat(exchangeRate.base_value).toFixed(4)}} (BNR)</div>
                                                <div v-else-if="exchangeRate.markup_type === 'PERCENTAGE'">
                                                    {{(parseFloat(exchangeRate.base_value) * (100 + parseFloat(exchangeRate.markup)) / 100).toFixed(4)}}
                                                    (BNR + {{exchangeRate.markup}}%)
                                                </div>
                                                <div v-else-if="exchangeRate.markup_type === 'ABSOLUTE'">
                                                    {{(parseFloat(exchangeRate.base_value) + parseFloat(exchangeRate.markup)).toFixed(4)}}
                                                    (BNR + {{exchangeRate.markup}} RON)
                                                </div>
                                                <div v-else-if="exchangeRate.markup_type === 'EXACT'">
                                                    {{(parseFloat(exchangeRate.markup)).toFixed(4)}}
                                                    (Manual)
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <h2>Informații</h2>
                                    <div class="row">
                                        <div class="col-sm-4 label">Adaos comercial implicit</div>
                                        <div class="col-sm-8">
                                            <div v-if="!offer.offer.default_markup_type">Fără adaos</div>
                                            <div v-else-if="offer.offer.default_markup_type === 'PERCENTAGE'">
                                                {{offer.offer.default_markup}}%
                                            </div>
                                            <div v-else-if="offer.offer.default_markup_type === 'ABSOLUTE'">
                                                {{offer.offer.default_markup}} RON
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="offer.offer.extra_data">
                                        <div class="row" v-if="offer.offer.extra_data.clientName">
                                            <div class="col-sm-4 label">Nume client</div>
                                            <div class="col-sm-8">{{ offer.offer.extra_data.clientName }}</div>
                                        </div>
                                        <div class="row" v-if="offer.offer.extra_data.offerTitle">
                                            <div class="col-sm-4 label">Titlu ofertă</div>
                                            <div class="col-sm-8">{{ offer.offer.extra_data.offerTitle }}</div>
                                        </div>
                                        <div class="row" v-if="offer.offer.extra_data.delivery">
                                            <div class="col-sm-4 label">Termen de livrare</div>
                                            <div class="col-sm-8">{{ offer.offer.extra_data.delivery }}</div>
                                        </div>
                                        <div class="row" v-if="offer.offer.extra_data.transport">
                                            <div class="col-sm-4 label">Transport</div>
                                            <div class="col-sm-8">{{ offer.offer.extra_data.transport }}</div>
                                        </div>
                                        <div class="row" v-if="offer.offer.extra_data.warranty">
                                            <div class="col-sm-4 label">Garanție</div>
                                            <div class="col-sm-8">{{ offer.offer.extra_data.warranty }}</div>
                                        </div>
                                        <div class="row" v-if="offer.offer.extra_data.details">
                                            <div class="col-sm-4 label">Detalii</div>
                                            <div class="col-sm-8">
                                                <span style="white-space: pre;">{{ offer.offer.extra_data.details }}</span>
                                            </div>
                                        </div>
                                        <div class="row" v-if="offer.offer.extra_data.stamp !== undefined">
                                            <div class="col-sm-4 label">Ștampilă</div>
                                            <div class="col-sm-8" v-if="offer.offer.extra_data.stamp">Da</div>
                                            <div class="col-sm-8" v-else>Nu</div>
                                        </div>
                                    </div>
                                </b-col>
                                <b-col md="5">
                                    <h2>Acțiuni</h2>

                                    <div class="row">
                                        <b-col sm="12">
                                            <b-button variant="success" @click="() => createOrder(offer.offer.offer_id)">
                                                <b-icon icon="cart4" />
                                                Comandă
                                            </b-button>
                                            <router-link :to="`/offer/${offer.offer.offer_id}/edit`" v-slot="{ href, navigate }">
                                                <a :href="href" @click="navigate">
                                                    <b-button class="ml-2" variant="secondary">
                                                        <b-icon icon="pencil-square" />
                                                        Editează
                                                    </b-button>
                                                </a>
                                            </router-link>
                                            <b-button class="ml-2" variant="danger" @click="() => deleteOffer(offer.offer.offer_id)">
                                                <b-icon icon="trash" />
                                                Șterge
                                            </b-button>
                                        </b-col>
                                    </div>

                                    <h2 class="mt-3">Export</h2>
                                    <div class="row">
                                        <b-col sm="12">
                                            <b-button variant="outline-danger" @click="() => downloadPdfFile(offer.offer.offer_id)">
                                                <b-icon icon="file-text" />
                                                PDF
                                            </b-button>
                                            <b-button class="ml-2" variant="outline-success" @click="() => downloadXlsxFile(offer.offer.offer_id)">
                                                <b-icon icon="file-spreadsheet" />
                                                Excel (XLSX)
                                            </b-button>
                                        </b-col>
                                    </div>
                                </b-col>
                            </b-row>

                        </div>

                        <div v-if="hasIssues" class="red page">
                            <h1>Probleme de integritate</h1>

                            <p>
                                Au fost găsite probleme de integritate la această ofertă.
                                Acest lucru înseamnă că informațiile de mai jos nu mai sunt de actualitate.
                            </p>

                            <p>
                                Vă rugăm să luați la cunoștință erorile de mai jos, și în cazul în care acestea
                                pun probleme, să le remediați din secțiunea de editare a ofertei.
                            </p>

                            <template v-if="this.issues.changed_currencies.length > 0">
                                <hr />

                                <h2>Cursuri valutare schimbate</h2>
                                <p>
                                    Au fost detectate schimbări ale cursurilor valutare utilizate pentru calculul
                                    prețurilor din această ofertă:
                                </p>
                                <ul>
                                    <li v-for="(info, index) in this.issues.changed_currencies" :key="index">
                                        1 {{info.currency}} s-a schimbat din
                                        {{parseFloat(info.old_value).toFixed(4)}} RON în
                                        {{parseFloat(info.new_value).toFixed(4)}} RON
                                    </li>
                                </ul>
                            </template>

                            <template v-if="this.issues.changed_offer_items.length > 0">
                                <hr />

                                <h2>Informații de stoc actualizate</h2>
                                <p>
                                    Au fost detectate schimbări ale informațiilor de stoc utilizate în cadrul acestei oferte:
                                </p>

                                <table class="table table-sm table-borderless table-striped">
                                    <thead>
                                        <tr>
                                            <th scope="col">Denumire produs</th>
                                            <th scope="col">Furnizor</th>
                                            <th scope="col" class="nowrap">Preț vechi</th>
                                            <th scope="col" class="nowrap">Preț nou</th>
                                            <th scope="col" class="nowrap">Stoc vechi</th>
                                            <th scope="col" class="nowrap">Stoc nou</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(info, index) in this.issues.changed_offer_items" :key="index">
                                            <td>{{info.product_name}}</td>
                                            <td>{{info.supplier_name}}</td>

                                            <template v-if="(info.old_product_stock.price != info.new_product_stock.price) || (info.old_product_stock.currency != info.new_product_stock.currency)">
                                                <td class="nowrap">{{parseFloat(info.old_product_stock.price).toFixed(2)}} {{info.old_product_stock.currency}}</td>
                                                <td class="nowrap">{{parseFloat(info.new_product_stock.price).toFixed(2)}} {{info.new_product_stock.currency}}</td>
                                            </template>
                                            <template v-else-if="info.old_product_stock.ron_price != info.new_product_stock.ron_price">
                                                <td class="nowrap">{{parseFloat(info.old_product_stock.ron_price).toFixed(2)}} RON</td>
                                                <td class="nowrap">{{parseFloat(info.new_product_stock.ron_price).toFixed(2)}} RON</td>
                                            </template>
                                            <template v-else>
                                                <td class="nowrap"></td>
                                                <td class="nowrap"></td>
                                            </template>

                                            <template v-if="info.old_product_stock.quantity != info.new_product_stock.quantity">
                                                <td class="nowrap">{{parseFloat(info.old_product_stock.quantity).toFixed(0)}}</td>
                                                <td class="nowrap">{{parseFloat(info.new_product_stock.quantity).toFixed(0)}}</td>
                                            </template>
                                            <template v-else>
                                                <td class="nowrap"></td>
                                                <td class="nowrap"></td>
                                            </template>
                                        </tr>
                                    </tbody>
                                </table>
                            </template>

                            <template v-if="this.issues.unavailable_offer_items.length > 0">
                                <hr />

                                <h2>Informații de stoc radiate</h2>
                                <p>
                                    Au fost detectate ștergeri ale informațiilor de stoc utilizate în cadrul acestei oferte.
                                    Nu s-au putut găsi automat versiuni mai noi ale acestor informații.
                                </p>
                                <p>Produse la care s-au constatat astfel de erori:</p>
                                <ul>
                                    <li v-for="(info, index) in this.issues.unavailable_offer_items" :key="index">
                                        <strong>{{info.product_name}}</strong>
                                    </li>
                                </ul>
                            </template>
                        </div>

                        <div class="page">
                            <h1>Produse</h1>

                            <table class="table table-sm table-borderless table-striped">
                                <thead>
                                    <tr>
                                        <th scope="col">Denumire</th>
                                        <th scope="col">Producător</th>
                                        <th scope="col">Furnizor</th>
                                        <th scope="col">Preț furnizor</th>
                                        <th scope="col">Adaos</th>
                                        <th scope="col">Cantitate</th>
                                        <th scope="col" class="nowrap">Preț final</th>
                                        <th scope="col">Profit</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="product in offer.products" :key="product.item_id">
                                        <td>
                                            {{product.name}}
                                            <br/>
                                            <div class="product-codes">
                                                <span v-if="product.codes.product_info.ean">EAN: {{product.codes.product_info.ean}}</span>
                                                <span v-if="product.codes.product_info.upc">UPC: {{product.codes.product_info.upc}}</span>
                                                <span v-if="product.codes.product_info.oem_codes">
                                                    <span>OEM: </span>
                                                    <span v-for="code in product.codes.product_info.oem_codes" :key="code.id">
                                                        {{code.oem_code}}
                                                    </span>
                                                </span>
                                                <span v-for="code in product.codes.extra_ids" :key="code.value">{{code.id_name}}: {{code.value}}</span>
                                            </div>
                                        </td>
                                        <td>{{product.manufacturer}}</td>
                                        <td>{{product.supplier_name}}</td>
                                        <td class="nowrap">
                                            <span>{{parseFloat(product.supplier_price).toFixed(2)}} {{product.supplier_currency}}</span><br/>
                                            <span class="small-text">{{parseFloat(product.base_ron_price).toFixed(2)}} RON</span>
                                        </td>
                                        <td class="nowrap">
                                            <div v-if="!product.markup_type">Implicit</div>
                                            <div v-else-if="product.markup_type === 'PERCENTAGE'">
                                                {{product.markup}}%
                                            </div>
                                            <div v-else-if="product.markup_type === 'ABSOLUTE'">
                                                {{product.markup}} RON
                                            </div>
                                            <div v-else-if="product.markup_type === 'EXACT'">
                                                Preț fix: {{(parseFloat(product.markup)).toFixed(2)}}
                                            </div>
                                        </td>
                                        <td class="nowrap">{{product.quantity}}</td>

                                        <td v-if="product.quantity > 1" class="nowrap">
                                            <span>{{(product.ron_unit_price * product.quantity).toFixed(2)}} RON</span><br>
                                            <span class="small-text">{{product.ron_unit_price}} RON / buc</span>
                                        </td>
                                        <td v-else>
                                            {{product.ron_unit_price}} RON
                                        </td>

                                        <td v-if="product.quantity > 1" class="nowrap">
                                            <span>{{(product.ron_profit * product.quantity).toFixed(2)}} RON</span><br>
                                            <span class="small-text">{{product.ron_profit}} RON / buc</span>
                                        </td>
                                        <td v-else>
                                            {{product.ron_profit}} RON
                                        </td>
                                    </tr>

                                </tbody>
                            </table>

                            <div class="total">
                                <span class="mr-3">Preț total:</span>
                                <span class="amount">
                                    {{parseFloat(offer.offer.total_price).toFixed(2)}} RON
                                </span>
                            </div>

                            <div class="total">
                                <span class="mr-3">Profit total:</span>
                                <span class="amount">
                                    {{parseFloat(offer.offer.total_profit).toFixed(2)}} RON
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from "@/utils/axios-instance";

    export default {
        name: 'Offer',
        components: {},
        data() {
            return {
                isLoaded: false,
                offer: null,
                issues: null,
            }
        },
        computed: {
            offerID() {
                return this.$route.params.id
            },
            hasIssues() {
                if(!this.issues) return false;

                if(this.issues.changed_currencies.length > 0) return true;
                if(this.issues.changed_offer_items.length > 0) return true;
                if(this.issues.unavailable_offer_items.length > 0) return true;

                return false;
            }
        },
        created: async function () {
            let loader = this.$loading.show({
                container: this.$refs.offer,
            });

            await this.loadOffer();
            await this.loadIssues();

            this.isLoaded = true;

            loader.hide();
        },
        watch: {
            // call again the method if the route changes
            '$route': 'fetchData'
        },
        methods: {
            async loadOffer() {
                let response = await axios.get(`offer/${this.offerID}`);
                this.offer = response.data;
            },
            async loadIssues() {
                let response = await axios.get(`offer/${this.offerID}/integrity-issues`);
                this.issues = response.data;
            },
            async createOrder(offerId) {
                let loader = this.$loading.show();

                try {
                    let response = await axios.post(`offer/${offerId}/create-order`);
                    await this.$store.dispatch('reloadEditingOrders');
                    await this.$router.push(`/order/${response.data.id}/edit`);
                } catch (e) {
                    console.log(e);
                }

                loader.hide();
            },
            async deleteOffer(offerId) {
                let loader = this.$loading.show();

                try {
                    await axios.delete(`offer/${offerId}`);
                    await this.$router.push(`/saved-offers`);
                } catch (e) {
                    console.log(e);
                }

                loader.hide();
            },
            async downloadPdfFile(offerId) {
                let loader = this.$loading.show();

                let response = await axios({
                    url: `offer/${offerId}/view/pdf`,
                    method: 'GET',
                    responseType: 'blob',
                });


                let fileURL = window.URL.createObjectURL(new Blob([response.data]));
                let fileLink = document.createElement('a');

                fileLink.href = fileURL;
                fileLink.setAttribute('download', 'Oferta.pdf');
                document.body.appendChild(fileLink);

                fileLink.click();

                loader.hide();
            },
            async downloadXlsxFile(offerId) {
                let loader = this.$loading.show();

                try {
                    let response = await axios({
                        url: `offer/${offerId}/view/xlsx`,
                        method: 'GET',
                        responseType: 'blob',
                    });


                    let fileURL = window.URL.createObjectURL(new Blob([response.data]));
                    let fileLink = document.createElement('a');

                    fileLink.href = fileURL;
                    fileLink.setAttribute('download', 'Oferta.xlsx');
                    document.body.appendChild(fileLink);

                    fileLink.click();
                } catch (e) {
                    console.log(e);
                }

                loader.hide();
            },
        }
    }
</script>

<style scoped lang="scss">
.search-page {
  flex-grow: 1;
  display: flex;
}

.page-content {
  flex-grow: 1;
  position: relative;
}

.cover {
  width: 100%;
  height: 264px;
  position: relative;
  background: #024A8C;
}

.container {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.content {
  margin-top: 60px;
  color: white;
  width: 100%;
}

.page {
  background: white;
  border-radius: 5px;
  color: black;
  padding: 25px 20px;

  margin-top: 50px;
  margin-bottom: 20px;

  -webkit-box-shadow: 0 0 14px 2px rgba(0, 0, 0, 0.31);
  -moz-box-shadow: 0 0 14px 2px rgba(0, 0, 0, 0.31);
  box-shadow: 0 0 14px 2px rgba(0, 0, 0, 0.31);

  p {
    margin: 0;
  }

  h1 {
    color: #024A8C;
    font-weight: 600;
  }

  h2, h3, h4, h5, h6 {
    color: #6F6F6F;
    margin-top: 20px;
    margin-bottom: 10px;
  }

  table th {
    color: #024A8C;
    font-weight: 600;
  }
}

.red.page {
  background: darkred;
  color: #e8e8e8;

  h1, h2, h3, h4, h5, h6 {
    color: #FFFFFF;
  }

  table th {
    color: #dadada;
  }

  table td {
    color: #FFFFFF;
  }
}


h1 {
  font-size: 2rem;
}

h2 {
  font-size: 1.1rem;
}

h3 {
  font-size: 1rem;
}

table td {
  white-space: normal;
  vertical-align: middle;
}

table td.nowrap, table th.nowrap {
  width: 1%;
  white-space: nowrap;
}

.small-text {
  color: #6F6F6F;
  font-size: 0.7rem;
  word-wrap: break-word;
}

.product-codes {
  color: #6F6F6F;
  font-size: 0.7rem;
  word-wrap: break-word;
}

.product-codes > span::after {
  content: '; ';
}

.total {
  color: #024A8C;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.total .amount {
  font-weight: 800;
  font-size: 1.3rem;
}

.label {
  color: #024A8C;
  font-weight: 600;
}
</style>
